"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _noop = _interopRequireDefault(require("lodash/noop"));

var _styledComponents = require("styled-components");

var _oxygenConfig = require("@8x8/oxygen-config");

var _oxygenConstants = require("@8x8/oxygen-constants");

var _types = require("../constants/types");

var _themeName = _interopRequireDefault(require("../constants/themeName"));

var _InputIcon = _interopRequireDefault(require("../styled/InputIcon"));

var _InputField = _interopRequireDefault(require("../styled/InputField"));

var _InputWrapper = _interopRequireDefault(require("../styled/InputWrapper"));

var _InputDecorator = _interopRequireDefault(require("../styled/InputDecorator"));

var _InputFieldWrapper = _interopRequireDefault(require("../styled/InputFieldWrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Input =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Input, _PureComponent);

  function Input() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Input);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Input)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      focused: false
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      if (_this.props.focus && _this.inputFieldRef && _this.inputFieldRef.current) {
        _this.inputFieldRef.current.focus();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleFocus", function () {
      _this.setState({
        focused: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleBlur", function () {
      _this.setState({
        focused: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "inputFieldRef", (0, _react.createRef)());

    return _this;
  }

  _createClass(Input, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          theme = _this$props.theme,
          id = _this$props.id,
          name = _this$props.name,
          value = _this$props.value,
          placeholder = _this$props.placeholder,
          type = _this$props.type,
          size = _this$props.size,
          prefix = _this$props.prefix,
          suffix = _this$props.suffix,
          IconLeft = _this$props.iconLeft,
          IconRight = _this$props.iconRight,
          fixed = _this$props.fixed,
          hasError = _this$props.hasError,
          isDisabled = _this$props.isDisabled,
          fullWidth = _this$props.fullWidth,
          onKeyUp = _this$props.onKeyUp,
          onKeyDown = _this$props.onKeyDown,
          onChange = _this$props.onChange,
          otherProps = _objectWithoutProperties(_this$props, ["theme", "id", "name", "value", "placeholder", "type", "size", "prefix", "suffix", "iconLeft", "iconRight", "fixed", "hasError", "isDisabled", "fullWidth", "onKeyUp", "onKeyDown", "onChange"]);

      var focused = this.state.focused;
      return _react.default.createElement(_styledComponents.ThemeProvider, {
        theme: theme
      }, _react.default.createElement(_InputWrapper.default, _extends({
        size: size,
        isDisabled: isDisabled,
        fixed: fixed,
        fullWidth: fullWidth
      }, otherProps), prefix && _react.default.createElement(_InputDecorator.default, {
        focused: focused,
        hasError: hasError,
        isPrefix: !!prefix
      }, _react.default.createElement("span", null, prefix)), _react.default.createElement(_InputFieldWrapper.default, {
        withPrefix: !!prefix,
        withSuffix: !!suffix,
        fixed: fixed,
        focused: focused,
        hasError: hasError
      }, IconLeft && _react.default.createElement(_InputIcon.default, null, _react.default.createElement(IconLeft, {
        color: theme.colorIcon
      })), _react.default.createElement(_InputField.default, {
        ref: this.inputFieldRef,
        id: id,
        name: name,
        type: type,
        value: value,
        autoComplete:'nope',
        placeholder: placeholder,
        fixed: fixed,
        disabled: fixed || isDisabled,
        onBlur: this.handleBlur,
        onFocus: this.handleFocus,
        onKeyUp: onKeyUp,
        onKeyDown: onKeyDown,
        onChange: onChange
      }), IconRight && _react.default.createElement(_InputIcon.default, {
        marginLeft: true
      }, _react.default.createElement(IconRight, {
        color: theme.colorIcon
      }))), suffix && _react.default.createElement(_InputDecorator.default, {
        focused: focused,
        hasError: hasError,
        isSuffix: !!suffix
      }, _react.default.createElement("span", null, suffix))));
    }
  }]);

  return Input;
}(_react.PureComponent);

_defineProperty(Input, "propTypes", {
  /**
   * Input theme
   */
  theme: _propTypes.default.object.isRequired,

  /**
   * Define id attribute for input element
   */
  id: _propTypes.default.string,

  /**
   * Define name attribute for input element
   */
  name: _propTypes.default.string,

  /**
   * Value / Initial value of the input
   */
  value: _propTypes.default.string,

  /**
   * Render placeholder text inside input
   */
  placeholder: _propTypes.default.string,

  /**
   * Define type of Input
   */
  type: _propTypes.default.oneOf([_types.DATE, _types.EMAIL, _types.NUMBER, _types.PASSWORD, _types.TEXT, _types.URL]),

  /**
   * Define Input size
   */
  size: _propTypes.default.oneOf([_oxygenConstants.inputSize.small, _oxygenConstants.inputSize.default]),

  /**
   * Show text in front of input
   */
  prefix: _propTypes.default.string,

  /**
   * Show text just after input
   */
  suffix: _propTypes.default.string,

  /**
   * Show icon inside input on the left side
   */
  iconLeft: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.node, _propTypes.default.element]),

  /**
   * Show icon inside input on the right side
   */
  iconRight: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.node, _propTypes.default.element]),

  /**
   * Tell when Input is focus
   */
  focus: _propTypes.default.bool,

  /**
   * Render input as pure text
   */
  fixed: _propTypes.default.bool,

  /**
   * Tell when Input has error
   */
  hasError: _propTypes.default.bool,

  /**
   * Tell when Input is disabled
   */
  isDisabled: _propTypes.default.bool,

  /**
   * Tell when Input is stretched
   */
  fullWidth: _propTypes.default.bool,

  /**
   * Callback when the input change
   */
  onChange: _propTypes.default.func,

  /**
   * Standard input onkeyup event
   */
  onKeyUp: _propTypes.default.func,

  /**
   * Standard input onkeydown event
   */
  onKeyDown: _propTypes.default.func

});

_defineProperty(Input, "defaultProps", {
  id: undefined,
  name: undefined,
  value: undefined,
  placeholder: '',
  type: _types.TEXT,
  size: _oxygenConstants.inputSize.default,
  prefix: '',
  suffix: '',
  iconLeft: null,
  iconRight: null,
  focus: false,
  fixed: false,
  hasError: false,
  isDisabled: false,
  fullWidth: true,
  onKeyUp: _noop.default,
  onKeyDown: _noop.default,
  onChange: _noop.default,
});

var _default = (0, _oxygenConfig.withTheme)(Input, _themeName.default);

exports.default = _default;